import React, { useState, useEffect } from "react";
import { ReactComponent as CloseSVG } from "../../../assets/close.svg";
import {
  OPContainer,
  OPBox,
  OPHeader,
  OPWrapper,
} from "../settings/SettingsStyled";

import {
  BallContainer,
  SubTitle,
  BetInfoBox,
  Button,
  TitleS,
  Loader,
} from "./BetReplyStyled";
import { Title } from "../provFair/ProvFairStyled";
import { ResultBall } from "../../mines/mines/MainStyled";

import useExplosion from "../../explosion";

export default ({
  handleAbove,
  handleAboveAnim,
  aboveAnim,
  betReply,
  precision,
  handleNotification,
  roundID,
  audio,
}) => {
  const [, , mineLocation, ballsAround] = useExplosion(
    betReply && betReply.board,
    true
  );
  const [btnAnimation, setBtnAnimation] = useState(false);
  const [initAnim, setInitAnim] = useState(false);

  const handlePerfectWinLocation = (i) => {
    return (
      initAnim &&
      betReply &&
      !betReply.board.includes("0") &&
      !betReply.board.includes("3") &&
      i === parseInt(betReply.userSelected[betReply.userSelected.length - 1])
    );
  };

  const handleClassNames = (b) => {
    return (
      betReply &&
      initAnim &&
      ((b === "0" && "Y") || (b === "1" && "R") || (b === "2" && "S"))
    );
  };
  const [selectedAnimation, setSelectedAnimation] = useState(false);
  const copyToClipboard = (e) => {
    e.target.select();
    document.execCommand("copy");
    handleNotification("Copied to clipboard");
  };
  useEffect(() => {
    betReply &&
      betReply.round_id !== roundID &&
      handleNotification("Bet info is not found");
  }, [betReply, roundID, handleNotification]);
  return (
    <OPContainer aboveAnim={aboveAnim} className="prov">
      <OPWrapper>
        <OPBox
          aboveAnim={aboveAnim}
          onAnimationEnd={() => {
            setInitAnim(true);
          }}
        >
          <OPHeader aboveAnim={aboveAnim} close={btnAnimation === "close"}>
            <p>Bet Reply</p>
            <span
              onAnimationEnd={() => setBtnAnimation(false)}
              onClick={() => {
                setBtnAnimation("close");
                audio.goBack();
                handleAboveAnim(false);
                setTimeout(() => {
                  handleAbove(false);
                }, 100);
              }}
            >
              <CloseSVG />
            </span>
          </OPHeader>
          {betReply && betReply.round_id === roundID ? (
            <>
              <TitleS>Bet ID</TitleS>
              <SubTitle>{betReply.bet_id}</SubTitle>
              <BallContainer>
                {betReply.board.map((ball, index) => (
                  <ResultBall
                    mineLocation={initAnim && mineLocation}
                    isMine={initAnim && ball === "3"}
                    perfectWin={handlePerfectWinLocation(index)}
                    ballsAround={ballsAround}
                    key={index}
                    className={handleClassNames(ball)}
                    selectedAnimation={selectedAnimation}
                    onAnimationEnd={() => setSelectedAnimation(true)}
                  >
                    <span />
                    <span />
                    <span />
                    <span />
                  </ResultBall>
                ))}
              </BallContainer>
              <BetInfoBox>
                <TitleS>Bet</TitleS>
                <SubTitle>
                  {betReply && betReply.betAmount.toFixed(precision)}{" "}
                  {betReply && betReply.currency}
                </SubTitle>
                <TitleS>Payout</TitleS>
                <SubTitle>
                  {betReply && betReply.currentCoeff > 0
                    ? betReply.currentCoeff
                    : "0.00"}{" "}
                  X
                </SubTitle>
                <TitleS>Win</TitleS>
                <SubTitle>
                  {betReply && betReply.winAmount > 0
                    ? betReply.winAmount
                    : "0.00"}{" "}
                  {betReply && betReply.currency}
                </SubTitle>
              </BetInfoBox>
              <Title>
                <h4>Clients seed</h4>
                <textarea
                  onClick={(e) => copyToClipboard(e)}
                  value={betReply.client_seed}
                  spellCheck="false"
                  readOnly="readOnly"
                />
              </Title>
              <Title>
                <h4>
                  {betReply.server_seed !== ""
                    ? "Server seed"
                    : "Server seed hash"}
                </h4>
                <textarea
                  onClick={(e) => copyToClipboard(e)}
                  value={
                    betReply.server_seed !== ""
                      ? betReply.server_seed
                      : betReply.server_seed_SHA256
                  }
                  spellCheck="false"
                  readOnly="readOnly"
                />
              </Title>
              <Title>
                <h4>Nonce</h4>
                <textarea
                  onClick={(e) => copyToClipboard(e)}
                  value={betReply.nonce}
                  spellCheck="false"
                  readOnly="readOnly"
                  className="nonce"
                />
              </Title>
            </>
          ) : (
            <Loader>
              <p className="loading">
                Loading
                <span />
                <span />
                <span />
              </p>
            </Loader>
          )}
          <Button
            btnAnimation={btnAnimation === "ok"}
            onAnimationEnd={() => setBtnAnimation(false)}
            onClick={() => {
              setBtnAnimation("ok");
              audio.confirm();
              setTimeout(() => {
                handleAbove("history");
                handleAboveAnim(true);
              }, 167);
            }}
          >
            OK
          </Button>
        </OPBox>
      </OPWrapper>
    </OPContainer>
  );
};
